import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class EventBusService {
  private eventEmitters: Map<string, EventEmitter<any>> = new Map();

  constructor() {}

  emit(eventName: string, data?: any): void {
    let emitter = this.eventEmitters.get(eventName);
    if (!emitter) {
      emitter = new EventEmitter<any>();
      this.eventEmitters.set(eventName, emitter);
    }
    emitter.emit(data);
  }

  on(eventName: string): Observable<any> {
    let emitter = this.eventEmitters.get(eventName);
    if (!emitter) {
      emitter = new EventEmitter<any>();
      this.eventEmitters.set(eventName, emitter);
    }
    return emitter.asObservable();
  }
}
